export const DestinationMapVisibility = {
    APPEARS_LAST: 1,
    APPEARS_AT_MID_ZOOM: 2,
    APPEARS_FIRST: 3,
} as const;
